import type ServiceApi from "../../api";
import {RevaApi} from "../api-constants";
import {SimpleApiInterface} from "../api-interface";
import type {ApiCredentials} from "../credentials";
import type {ApiExecutor} from "../executor";
import type {IdpEnergyResult} from "../payload-types/idp-energy";

/**
 * API interface for the energy-certificate IDP request (POST {@link RevaApi.PATH_IDP_ENERGY}).
 *
 * The raw PDF bytes are sent as an octet-stream body; the file name is passed as the required
 * `pdfFileName` query parameter. The request is proxied by reva-rest to the Humboldt IDP-Energy
 * service, which returns the extracted values as JSON keyed by REVA parameter key.
 */
export class IdpEnergyApiInterface extends SimpleApiInterface<IdpEnergyResult> {
    private readonly pdfFileName: string;
    private readonly body: ArrayBuffer;

    constructor(pdfFileName: string, body: ArrayBuffer) {
        super();
        this.pdfFileName = pdfFileName;
        this.body = body;
    }

    protected buildUrl(api: ServiceApi): string {
        return api.buildRevaApiUrl([RevaApi.PATH_IDP_ENERGY], {pdfFileName: this.pdfFileName});
    }

    protected async executeInternal(
        executor: ApiExecutor,
        url: string,
        credentials: ApiCredentials,
    ): Promise<IdpEnergyResult> {
        return executor.fetchPOSTBinary(url, credentials, this.body);
    }
}
